import { useModal } from '@/components/Modal'
import { Modal } from '@/ui/Modal'
import styles from './ChangeRunModal.module.scss'
import { Button } from '@/ui/Button'

type Props = {
    newRun: string
    oldRun: string
    confirm: () => void
    cancel: () => void
}

export const ChangeRunModal = () => {
    const { props, closeModal } = useModal<Props>()

    const handleConfirm = () => {
        props?.confirm()
        closeModal()
    }

    const handleCancel = () => {
        props?.cancel()
        closeModal()
    }

    if (!props) {
        return null
    }

    return (
        <Modal onClose={closeModal} className={styles.modal} hideCloseButton>
            <div className={styles.information}>
                <h1 className={styles.title}>Change run [{props.newRun}]?</h1>
                <p className={styles.description}>
                    This bus is currently allocated to run <strong>[{props.oldRun}]</strong>. Are you sure you want to
                    move it to <strong>[{props.newRun}]</strong>?
                </p>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button rounded variant="secondary" onClick={handleConfirm}>
                    Yes, move
                </Button>
            </div>
        </Modal>
    )
}
